import { networkService } from "./network-service";

class BusinessService {
    async getBusinessById(id: string) {
        return await networkService.get(`/businesses/${id}`)
    }
 
    async getCategories() {
        return await networkService.get(`/categories`);
    }
 
}

export const businessService = new BusinessService();